// extracted by css-extract-rspack-plugin
export default {"wrapper":"_a04893c3","fullWidthWrapper":"_26575a16","innerWrapper":"_ef64621d","fullWidthInnerWrapper":"_82671988","link":"_56f87810","specify":"_df0cf083"};